import {
  connect
} from 'react-redux';
import {
  compose, lifecycle, renderNothing, branch, renderComponent
} from 'recompose';
import {
  bindActionCreators
} from 'redux';
import Loading from '../pages/loading';
import {
  sessionActions
} from '../../state/modules/session';

const Logout = renderNothing();

export default compose(
  connect(({
    configuration: {
      auth0Config
    }
  }) => ({
    auth0Config
  }), (dispatch) => ({
    logout: bindActionCreators(sessionActions.session.logout, dispatch)
  })),
  branch(
    ({ auth0Config }) => !auth0Config,
    renderComponent(Loading)
  ),
  lifecycle({
    componentDidMount() {
      this.props.logout();
    }
  })
)(Logout);



// WEBPACK FOOTER //
// ./src/containers/pages/logout.js